/* eslint-disable max-len */
const faqContent = '<h2>Frequently Asked Questions</h2><br>' +
'<p><b>Q: Why aren\'t there any products on this page?</b></p><br>' +
'<p>A: Either we haven\'t started the promotion yet or your Brand Executive hasn\'t shared purchase access with you.</p><br><br>' +
'<p><b>Q: I stumbled upon this page by accident.  Can I purchase them?</b></p><br>' +
'<p>A: No</p><br><br>' +
'<p><b>Q: What do I need to do to be able to purchase these early access products?</b></p><br>' +
'<p>A: Contact your Brand Executive and ask them if they have any available purchase access that they can share with you.<p><br><br>'

// Defaults for tdc for fallback.
const constructTdc = () => ({
  tdc_accepted: 'Accepted',
  tdc_addOnAddToCart: 'Add to Cart',
  tdc_addOnBadgeTextAvailable: 'Add-ons available',
  tdc_addOnBadgeTextConditionally: 'Add-ons available when you add above item to your cart',
  tdc_addOnQuantityLabel: 'Quantity',
  tdc_actions: 'Actions',
  tdc_all: 'All',
  tdc_allClaimedMessage: 'Wonderful! We are excited for you to come back when the event starts',
  tdc_allocationManagerText: 'Manage the allocations that have been sent to you, or that you have sent to others. Some options may not be available for everyone.',
  tdc_allocationManagerTitle: 'Allocation Manager',
  tdc_allocationMessage: 'Your Allocations to Purchase or Transfer',
  tdc_allocationStatus: 'Allocation Status',
  tdc_availableSupplies: '*Available while supplies last',
  tdc_backToHome: 'Back to Home',
  tdc_cancel: 'Cancel',
  tdc_claimedAll: 'Wants All',
  tdc_claimedNone: 'Wants None',
  tdc_claimedSome: 'Wants Some',
  tdc_declined: 'Declined',
  tdc_earlyAccessTitle: 'Early Access Purchase',
  tdc_failedToSendQualifications: 'Oops, it looks like something went wrong and the transfer failed...',
  tdc_faq: 'Frequently Asked Questions',
  tdc_faqContent: faqContent,
  tdc_goButton: 'GO',
  tdc_limitReached: 'Limit Reached',
  tdc_loadQualificationsError: 'We encountered an error loading your data. Please reload the page to try again',
  tdc_loadQualificationProductDataError: 'One of your products could not be loaded',
  tdc_letUplineKnow: 'Let your friend know how many of their shared products you want to order',
  tdc_manageButton: 'Manage My Allocations',
  tdc_noItemsText: 'You don\'t have any items available to purchase. Ask a sales leader to share some of their product with you.',
  tdc_noItemsTitle: 'You don\'t have any items available to purchase',
  tdc_none: 'None',
  tdc_noneClaimedMessage: 'Thanks for letting us know! {returnUnclaimed}',
  tdc_noReturnsFound: 'No returnable items found.',
  tdc_notCountingAddon: '(Not counting the add-on products)',
  tdc_otherMarketsDisclaimer: '*Some products may be purchasable in multiple markets, whereas some are only available in one market.',
  tdc_otherMarketsDropdownLabel: 'View Products in other Markets',
  tdc_otherMarketsTitle: 'You have products available for purchase in other markets*',
  tdc_partialReturnHeaderText: 'Transfer your allocation back to your Sales Leader.',
  tdc_partialReturnHeaderTitleText: 'Return Your Allocation',
  tdc_partialReturnListTitle: 'Returnable Allocation',
  tdc_purchased: 'Purchased',
  tdc_purchaseIntentError: 'There was an error updating your intent to purchase your available product(s).',
  tdc_qualificationsSent: 'Qualifications sent successfully',
  tdc_quantityLabel: 'Quantity',
  tdc_reclaim: 'Reclaim',
  tdc_reclaimHeader: 'Reclaim Items',
  tdc_reclaimText: 'This person will not be able to purchase these if you take them back. Please let them know.',
  tdc_reclaimToastError: 'Something went wrong. Please refresh and try again.',
  tdc_reclaimToastSuccess: 'Your allocation has been pulled back. Please let that person know!',
  tdc_remainingInventory: 'Remaining in your inventory',
  tdc_reservedForYou: 'Reserved for you',
  tdc_reservedForYouHeader: 'These products are <strong><em>reserved for you*</em></strong>. Buy some if you want, and share the rest with others.',
  tdc_returnAllAllocationsText: 'Return All Allocations',
  tdc_returnAllocationModalCancelText: 'Cancel',
  tdc_returnAllocationModalHeaderText: 'Are you sure you want to return these items?',
  tdc_returnAllocationModalReturnAllText: 'Return All Allocations',
  tdc_returnAllocationModalReturnSomeText: 'Return Items',
  tdc_returnAllocationModalText: 'They will be returned to the person who transferred them to you.',
  tdc_returnAllocationText: 'Return items that you are not interested so that your upline can share them to others who are interested.',
  tdc_returnAllocationTitle: 'Return Allocation',
  tdc_returnDialogMessage: 'They will be returned to the person who transferred them to you.',
  tdc_returnDialogTitle: 'Are you sure you want to return these items?',
  tdc_returnItemsButtonText: 'RETURN ITEMS',
  tdc_returnSelectedAllocationsText: 'Return Selected Items',
  tdc_returnToSharer: 'Return All Items To Original Sharer',
  tdc_returnTransferItemsMessage: 'If you do not wish to participate in this protmotion, you may transfer some or all of your items back to your Sales Leader.',
  tdc_returnTransferItemsNotice: '<p>Please Note: You will not be able to purchase the items transfered back to your Sales Leader.</p>',
  tdc_returnTransferItemsTitle: 'Return Your Items',
  tdc_returnUnclaimed: 'Return the allocations that you dont want.',
  tdc_searchButtonText: 'Search For Recipient',
  tdc_searchErrorText: 'No Results Found',
  tdc_searchLabel: 'Recipient Name/ID',
  tdc_searchResultsText: 'Search Results',
  tdc_selectAMarket: 'Select A Market',
  tdc_sendDialogMessage: 'Once you send these, you will not be able to get them back yourself.  You will have to ask the recipient to send them back to you.',
  tdc_sendDialogTitle: 'Are you sure you want to send these items?',
  tdc_sendItemsButtonText: 'Transfer Items ({numItems})',
  tdc_sendToOthers: 'Send to Others',
  tdc_sendToSomeone: 'Send To Someone',
  tdc_sent: 'Sent',
  tdc_some: 'Some',
  tdc_someClaimedMessage: 'Awesome! By the way, you can {returnUnclaimed}',
  tdc_statusQuantity: 'Quantity:',
  tdc_transferAllocationsFailed: 'Oops, it looks like something went wrong and the transfer failed...',
  tdc_transferAllocationText: 'Transfer some of your items to someone in your organization.',
  tdc_transferAllocationTitle: 'Transfer Your Allocations',
  tdc_transferItemsMessage: '<p>You may transfer the opportunity to purchase some or all of your items to anyone within your organization.</p>',
  tdc_transferItemsDisclaimer: 'We remind you that, in sharing your product allocation, you must do so in compliance with all applicable privacy laws and laws regarding the sending of marketing communications, including the CAN-SPAM Act of 2003. As a general rule, you should only share codes with individuals with whom you have a preexisting relationship, and you should not send unsolicited emails or texts.',
  tdc_transferItemsNotice: '<p>Please Note: The recipient may choose to purchase the item(s), return the purchase opportunity, or transfer the opportunity to another person.</p>',
  tdc_transferItemsTitle: 'Transfer Your Items',
  tdc_transferMarketRestrictions: 'Transfers for this promotion are not available in all markets.',
  tdc_transferOutOfMarketMessage: 'You are unable to transfer to this recipient due to their local market not being eligible for this promotion.',
  tdc_transferOutOfMarketWarning: 'Market not eligible',
  tdc_transferStatusPageText: 'Manage the allocations that you have sent to others. View offer status, and pull back allocations to your inventory.',
  tdc_transferStatusPageTitle: 'Transfer Status',
  tdc_transferStatusText: 'View the products you have transferred to others, and whether they have seen or purchased them. You can also pull them back and sent them to another.',
  tdc_transferStatusTitle: 'View Transfer Status',
  tdc_unidentifiedQualificationSharer: 'Sharer\'s name cannot be found.',
  tdc_variantDropdownLabel: 'Select a Product',
  tdc_viewed: 'Viewed',
  tdc_whatToSend: 'What would you like to send them?',
  tdc_whoToSendTo: 'Who would you like to send these to?',
})

/* eslint-disable no-undef */
// qualificationsConfig is injected via the shop-ui repository from the following file:
// src\main\content\jcr_root\apps\shop\components\qualifications\qualifications.jsp
const constructQualificationsConfig = () => {
  const tdc = constructTdc()
  if (!qualificationsConfig) {
    return {
      products: [],
      showTransferItemsInformation: true,
      tdc,
    }
  }
  const config = {
    products: qualificationsConfig.products || tdc.products,
    showTransferItemsInformation: qualificationsConfig.showTransferItemsInformation || tdc.showTransferItemsInformation,
    tdc: {
      ...tdc
    }
  }

  // Add all the tdc in the qulificationsConfig to the current config.
  Object.keys(qualificationsConfig).forEach(key => {
    if (key.startsWith('tdc_')) {
      config.tdc[key] = qualificationsConfig[key]
    }
  })

  return config
}

const config = constructQualificationsConfig()

/* eslint-enable no-undef */

const getConfig = () => {
  return config
}

const calculateKey = (providedKey) => {
  if (providedKey.includes('tdc_')) {
    return providedKey
  }
  return `tdc_${providedKey}`
}

const getTdcString = (key) => {
  const keyToUse = calculateKey(key)
  const config = getConfig()
  if (config && config.tdc && config.tdc[keyToUse]) {
    return config.tdc[keyToUse]
  }
  return null
}

const getTdc = () => {
  return getConfig().tdc
}

export default {
  getConfig,
  getTdcString,
  getTdc,
}
